var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DemoPanel',{attrs:{"name":"LineDivider"}},[_c('v-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('LineDivider',[_c('h3',[_vm._v("Linha divisória")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }